import { Modal } from "./Modal";

// Privacy/limits disclaimer dialog, opened from the footer link and the
// #disclaimer hash.
export function DisclaimerModal({ onClose }: { onClose: () => void }) {
  return (
    <Modal onClose={onClose}>
      <h2>Disclaimer</h2>
      <ul>
        <li>
          <strong>Browser-only analysis:</strong> Pasting, viewing, and analyzing
          happen entirely in your browser — that data is never sent to any
          server.
        </li>
        <li>
          <strong>Encrypted sharing:</strong> When you create a share link, your
          session is encrypted in your browser first. We upload only data we
          cannot read — the server stores ciphertext, and the decryption key stays
          in the link's <code>#</code> fragment, which is never sent to the
          server. Treat the link as a secret; anyone with it can read the session.
        </li>
        <li>
          <strong>Saved history:</strong> when signed in, sessions you explicitly{" "}
          <em>Save to History</em> are encrypted in your browser and stored as
          ciphertext we cannot read — the same zero-knowledge model as sharing. A
          saved entry stays <strong>private</strong> until you toggle Share on.
        </li>
        <li>
          <strong>No third-party tracking</strong> runs on this page. We keep
          first-party usage counts (which pages and features get used) to guide
          development. These counts include no file contents, no decryption keys,
          no IP address, and no account identity, and are never linked across
          sessions.
        </li>
        <li>
          <strong>Limits:</strong> Because the page is served to your browser, a
          compromised server could in principle serve tampered code. This tool is
          provided as-is, without warranties of any kind.
        </li>
      </ul>
    </Modal>
  );
}

export default DisclaimerModal;
